var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "600", persistent: "" },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-toolbar",
            { attrs: { color: "primary", dark: "", flat: "" } },
            [
              _c("v-toolbar-title", [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { icon: "" }, on: { click: _vm.close } },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-card-text", { staticClass: "modal-content" }, [
            _c(
              "div",
              { staticClass: "table-container" },
              [
                _c("div", { staticClass: "table-header" }, [
                  _c("div", { staticClass: "header-cell header-result" }, [
                    _vm._v("\n            Resultado\n          "),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "header-cell header-period" }, [
                    _vm._v("\n            Período\n          "),
                  ]),
                ]),
                _vm._v(" "),
                _vm._l(_vm.periods, function (period, index) {
                  return _c("div", { key: index, staticClass: "table-row" }, [
                    _c("div", { staticClass: "table-cell result-cell" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.formatCurrency(period.result || 0)) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "table-cell period-cell" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.formatPeriodDate(period.startDate)) +
                          " à " +
                          _vm._s(_vm.formatPeriodDate(period.endDate)) +
                          "\n          "
                      ),
                    ]),
                  ])
                }),
              ],
              2
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }